import { useAtomValue } from 'jotai';
import { useCallback, useMemo } from 'react';
import { Rubric } from '../../../../../schemas/Rubric.schema';
import { getPlainDateString } from '../../../../../services/queries/MaggieMetricsQueries';
import {
  mostRecentRubricsByCompanyIdAtom,
  rubricConfigByIdAtom,
} from '../../../../../services/state/RubricsStateJ';
import { selectedMetricsDateCPState } from '../../../state/CompanyFinancialsDateState';
import { selectedCompanyIdProfileAtom } from '../../../state/UIStateJ';

export function useRubricFormData() {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const rubricConfigsById = useAtomValue(rubricConfigByIdAtom);
  const selectedDate = useAtomValue(selectedMetricsDateCPState(companyId));
  const { data: rubrics } = useAtomValue(
    mostRecentRubricsByCompanyIdAtom({ companyId, date: getPlainDateString(selectedDate) })
  );
  const rubricsByConfigId = useMemo(() => {
    return rubrics?.reduce((acc, rubric) => {
      return acc.set(rubric.rubricConfigId, rubric);
    }, new Map<number, Rubric>());
  }, [rubrics]);

  const configOptions = useMemo(() => {
    if (!rubricConfigsById || !rubricsByConfigId) {
      return [];
    }
    return [...rubricConfigsById.values()].reduce((acc, c) => {
      if (!rubricsByConfigId.has(c.id)) {
        acc.push(c.id);
      }
      return acc;
    }, [] as number[]);
  }, [rubricConfigsById, rubricsByConfigId]);

  const getConfigLabel = useCallback(
    (id: number) => {
      return rubricConfigsById?.get(id)?.displayName ?? '';
    },
    [rubricConfigsById]
  );

  return { configOptions, getConfigLabel, selectedDate };
}
